import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Box, Flex, Text } from 'Components/Base';

import ReviewSelection from '../ReviewSelection';

const ReviewQuestionnaire = ({
  question,
  description,
  answerableCount,
  answerList,
  onChange,
  value,
  ...props
}) => {
  const questionnaire = useMemo(() => {
    return (
      <Flex flexDirection={'column'} alignItems={'center'}>
        <Text fontWeight={'medium'}>{question}</Text>
        {description && (
          <Text textStyle={'body2'} fontWeight={'normal'} color={'greyscale.grey3'} mt={2}>
            {description}
          </Text>
        )}
      </Flex>
    );
  }, [description, question]);

  return (
    <Box width={1} {...props}>
      {questionnaire}
      <ReviewSelection
        answerableCount={answerableCount}
        choices={answerList}
        value={value}
        mt={7}
        selectProps={
          answerableCount === 1
            ? { width: 1, mb: 4 }
            : { width: { _: 1, md: 'auto' }, mr: { md: 4 }, mb: 4 }
        }
        onChange={onChange}
      />
    </Box>
  );
};

ReviewQuestionnaire.propTypes = {
  question: PropTypes.string.isRequired,
  description: PropTypes.string,
  answerList: PropTypes.array.isRequired,
  answerableCount: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.array,
};

ReviewQuestionnaire.defaultProps = {
  answerableCount: 1,
  answerList: [],
  onChange: () => {},
};

export default ReviewQuestionnaire;
